<div class="pre-select-container">
<div class="pre-select-options">
    <dx-radio-group
      [items]="options"
      (valueChange)="setSelectedOptionsRapor($event)"
      [value]="defaultOption || options[0]"
      layout="horizontal"
    >
    </dx-radio-group>

</div>
<dx-toolbar class="bottomSaveCancelBtn">
  <dxi-item location="center">
    <dx-button stylingMode="contained" width="150" type="default" text="Seç"
               (onClick)="handleSelectClick()"></dx-button>
  </dxi-item>
</dx-toolbar>
</div>
